/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class StartNotebookSessionInput {
  /**
  * The Spark engine ID to attach the session to
  */
  'engineId': string;
  /**
  * The user starting the session
  */
  'userId'?: string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "engineId",
      "baseName": "engineId",
      "type": "string",
      "format": ""
    },
    {
      "name": "userId",
      "baseName": "userId",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return StartNotebookSessionInput.attributeTypeMap;
  }

  public constructor() {
  }
}

